"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendRequest = exports.HttpMethod = void 0;
const axios_1 = __importDefault(require("axios"));
var HttpMethod;
(function (HttpMethod) {
    HttpMethod["Get"] = "get";
    HttpMethod["Post"] = "post";
    HttpMethod["Delete"] = "delete";
})(HttpMethod = exports.HttpMethod || (exports.HttpMethod = {}));
async function sendRequest({ url, method, body }) {
    let response;
    try {
        response = await axios_1.default[method](url, body);
    }
    catch (error) {
        console.log(`${error.response.status} ${error.response.statusText}`);
        return error.response.data;
    }
    return response.data;
}
exports.sendRequest = sendRequest;
//# sourceMappingURL=httpRequests.js.map